import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPencilPaper = () => {
  return (
    <g>
      <path d="m1.95 12.915h4.0085a.7033.7033 0 0 0 .4951-.2051l.5527-.5527.0029-.002.0019-.0029 4.8662-4.8662.0029-.0019.002-.0029 1.9024-1.9023a.7.7 0 0 0 0-.99l-4.0087-4.009a.7.7 0 0 0 -.99 0l-1.9026 1.9022-.0029.002-.0019.0029-4.8663 4.8662-.0029.0019-.002.0029-.5527.5527a.7033.7033 0 0 0 -.2051.4951v4.0088a.7.7 0 0 0 .7005.7003zm.7-4.1289 2.7285 2.7285h-2.7285zm4.726-5.0161 3.0185 3.0186-3.8808 3.8808-3.0186-3.0185zm1.9048-1.9048 3.0185 3.0185-.9145.9146-3.0186-3.0183z" />
      <path d="m14.05 14.4248h-12.1a.7.7 0 1 0 0 1.4h12.1a.7.7 0 1 0 0-1.4z" />
    </g>
  );
};

export default withIcon(IconPencilPaper);
